import { login } from '@/api/auth'
import { getToken, setToken } from '@/utils/authUtils'

export const WECOM_CLIENT_ID = 'bc84e6c82e5f4bea008575701fd32ea5'

export async function ensureWecomLogin(code) {
  const token = getToken()
  if (token) {
    return token
  }
  // if (!code) {
  //   throw new Error('缺少企微授权code')
  // }
  const response = await login({
    wecomAuthCode: code,
    clientId: WECOM_CLIENT_ID,
    grantType: 'wecom'
  })
  setToken(response.access_token, 24 * 60 * 60 * 1000)
  return response.access_token
}